module.exports = __webpack_public_path__ + "static/media/support.701ac73c.webp";